<template>
  <BaseButton class="c" v-bind="$props" v-on="$attrs" @click="onClick">
    <template v-for="(_, name) in slotsFiltered" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>

    <div class="c__cnt">
      <slot />
    </div>

    <div class="c__progress" :style="`width: ${progress * 100}%`">
      <ProgressBar
        v-if="isProgressBarActive"
        v-show="false"
        :need-to-stop="needToStop"
        :value-initial="valueInitial"
        @inited="onProgressBarInited"
      />
    </div>
  </BaseButton>
</template>

<script lang="ts">
import { Ref, watch } from 'vue';

import BaseButton from '../Button/Button.vue';
import { ProgressBar } from '../ProgressBar';

export default {
  name: 'ButtonProgress',
  components: { BaseButton, ProgressBar },
  props: {
    ...BaseButton.props,
    needToReset: { type: Boolean },
    stopped: { type: Boolean },
    valueInitial: { default: 0, type: Number },
  },
  emits: {
    click: null,
    end: null,
  },
  data() {
    return {
      isProgressBarActive: false,
      needToStop: false,
      progress: 0,
    };
  },
  computed: {
    slotsFiltered() {
      const slots = this.$slots;
      const slotsFiltered = {} as Record<string, unknown>;

      for (const k in slots) {
        if (k === 'default') continue;
        slotsFiltered[k] = slots[k];
      }

      return slotsFiltered;
    },
  },
  watch: {
    stopped(v) {
      this.onStoppedUpdate(v);
    },
  },
  methods: {
    /* Methods */
    end() {
      this.resetAfterCheck();
      this.$emit('end');
    },
    reset() {
      this.isProgressBarActive = false;
      this.needToStop = false;
      this.progress = 0;
    },
    resetAfterCheck() {
      if (!this.needToReset) return;
      this.reset();
    },
    start() {
      this.reset();
      this.$nextTick(() => {
        this.isProgressBarActive = true;
      });
    },
    /* Handlers */
    onClick(e: Event) {
      this.start();
      this.$emit('click', e);
    },
    onProgressBarInited(progressRef: Ref<number>) {
      watch(
        progressRef,
        v => {
          if (v >= 1) {
            this.progress = 1;
            this.end();
            return;
          }
          this.progress = v;
        },
        { immediate: true }
      );
    },
    onStoppedUpdate(v: boolean) {
      if (!v) return;

      this.needToStop = true;
      setTimeout(() => this.resetAfterCheck(), 2000);
    },
  },
};
</script>

<style src="./ButtonProgress.scss" lang="scss" scoped />
